import { styled } from '../jss-style';
import cascaderStyle from './cascader';

const useCascaderStyle = styled(cascaderStyle, 'cascader');
export { cascaderStyle, useCascaderStyle };
export default useCascaderStyle;
